import React, { useMemo } from 'react'
import { Card, CardContent, Stack, Typography } from '@mui/material'
import ReactJson, { ReactJsonViewProps } from 'react-json-view'
import { useThemeType } from 'context/theme'

type JsonViewerProps = ReactJsonViewProps & {
  title?: string
}

const JsonViewer: React.FC<JsonViewerProps> = ({
  title = '',
  src,
  ...props
}) => {
  const { isDarkTheme } = useThemeType()

  const size = useMemo(() => {
    try {
      return src ? `${JSON.stringify(src)?.length.toLocaleString()} bytes` : ''
    } catch {
      return ''
    }
  }, [src])

  return (
    <Card variant='outlined' sx={{ my: 2 }}>
      <CardContent>
        <Stack direction='row' justifyContent='space-between'>
          <Typography variant='h6' gutterBottom>
            {title}
          </Typography>

          <Typography variant='caption' color='text.secondary'>
            {size}
          </Typography>
        </Stack>

        {src ? (
          <ReactJson
            src={src}
            name={false}
            collapsed={2}
            enableClipboard={true}
            displayDataTypes={false}
            displayObjectSize={false}
            indentWidth={2}
            style={{ fontSize: '14px' }}
            theme={isDarkTheme ? 'twilight' : 'rjv-default'}
            {...props}
          />
        ) : (
          <Typography variant='body2' color='text.secondary'>
            No data available
          </Typography>
        )}
      </CardContent>
    </Card>
  )
}

export default JsonViewer
